/* eslint-disable no-barrel-files/no-barrel-files */
export type { ConsequenceMatrixRiskResult } from './computeConsequenceMatrixRisk'
export { computeConsequenceMatrixRisk } from './computeConsequenceMatrixRisk'
export { ConsequenceMatrixSelector } from './ConsequenceMatrixSelector'
export { RiskBadge } from './RiskBadge'
export { RiskMatrix } from './RiskMatrix'
export {
  FALLBACK_CONSEQUENCE_LABELS,
  FALLBACK_LIKELIHOOD_LABELS,
  FALLBACK_RISK_MATRIX,
} from './riskMatrixDefaults'
export {
  calculateLikelihoodConsequence,
  calculateMatrixPosition,
  getIsLikelihoodAsRows,
} from './riskMatrixHelpers'
export { RiskSelectionModal } from './RiskSelectionModal'
